import { render, staticRenderFns } from "./instance-management-audit-details.component.vue?vue&type=template&id=0bb11050&scoped=true"
import script from "./instance-management-audit-details.component.vue?vue&type=script&lang=ts"
export * from "./instance-management-audit-details.component.vue?vue&type=script&lang=ts"
import style0 from "./instance-management-audit-details.component.vue?vue&type=style&index=0&id=0bb11050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb11050",
  null
  
)

export default component.exports